import React, { useState, useRef } from "react"
import {
  mainNav,
  navList,
  navItemName,
  navItem,
  subNavContainer,
  subNav,
  subNavName,
  subNavItemTitle,
} from "../header.module.scss"
import {
  NavItem,
  SubItemContainer,
  SubItem,
  SubNavItemTitle,
  MainNav,
} from "./main-menu-styled"
import PropTypes from "prop-types"
import ProcessedLink from "../../../processed-link"
import EditButton from "../../../EditButton/edit-button"

const MainMenu = ({ mainMenuData }) => {
  const menuItemRefs = useRef({})

  const menuWithoutParent = mainMenuData.filter(
    ({ node }) => !node.drupal_parent_menu_item
  )
  const menuWithParent = mainMenuData.filter(
    ({ node }) => node.drupal_parent_menu_item
  )
  const [expandedMenu, setExpandedMenu] = useState({})

  const toggleMenu = (id, expand) => {
    setExpandedMenu((prevState) => ({
      ...prevState,
      [id]: expand,
    }))
  }

  if (typeof document !== `undefined`) {
    document.addEventListener("keyup", (event) => {
      if (event.key === "Escape") {
        document.activeElement.blur()
        const filteredKeys = Object.entries(expandedMenu)
          .filter(([key, value]) => value === true)
          .map(([key, value]) => key)
        const currentElement = menuItemRefs.current[filteredKeys[0]]
        if (currentElement !== undefined) {
          currentElement.setAttribute("aria-expanded", false)
          if (currentElement.children.length >= 2) {
            const visibility = currentElement.children[1].style.visibility
            currentElement.children[1].style.visibility =
              visibility === "hidden" ? "visible" : "hidden"
          }
        }
      }
    })
  }

  let menuLevelThree
  let menuLevelTwo
  let menuAttributes

  return (
    <MainNav id="top" className={mainNav} role="navigation">
      <EditButton link={"/admin/structure/menu/manage/main"} />

      <ul className={navList} id="menuItems">
        {menuWithoutParent.map((item) => {
          menuLevelTwo = menuWithParent.filter(
            ({ node }) =>
              node.drupal_parent_menu_item ===
              `menu_link_content:${item.node.drupal_id}`
          )
          const isLink = !item.node.link.uri.includes("nolink")
          menuAttributes =
            menuLevelTwo.length > 0
              ? isLink
                ? {
                    ariaExpanded: expandedMenu[item.node.drupal_id] || false,
                  }
                : {
                    "aria-expanded": expandedMenu[item.node.drupal_id] || false,
                  }
              : {}
          menuAttributes.role = isLink ? null : "button"
          return (
            <NavItem
              key={item.node.drupal_id}
              ref={(el) => (menuItemRefs.current[item.node.drupal_id] = el)}
              className={navItem}
              aria-label={
                'Appuyer sur "Échap" pour cacher/montrer les sous-menus lors du survol'
              }
              onMouseOver={() => {
                toggleMenu(item.node.drupal_id, true)
              }}
              onMouseOut={() => {
                toggleMenu(item.node.drupal_id, false)
              }}
              onFocus={() => {
                toggleMenu(item.node.drupal_id, true)
              }}
              onBlur={() => {
                toggleMenu(item.node.drupal_id, false)
              }}
            >
              <div className={navItemName}>
                {menuLevelTwo.length === 0 ? (
                  <ProcessedLink link={item.node.link.uri}>
                    <span tabIndex="-1">
                      <span aria-hidden={true}></span>
                      {item.node.title}
                    </span>
                  </ProcessedLink>
                ) : (
                  <ProcessedLink
                    link={item.node.link.uri}
                    attributes={isLink ? menuAttributes : null}
                  >
                    <span
                      tabIndex={isLink ? "-1" : "0"}
                      {...(isLink ? {} : menuAttributes)}
                    >
                      <span aria-hidden={true}></span>
                      {item.node.title}
                    </span>
                  </ProcessedLink>
                )}
              </div>
              {menuLevelTwo.length > 0 && (
                <div className={subNavContainer}>
                  {menuLevelTwo.map((child) => {
                    menuLevelThree = menuWithParent.filter(
                      ({ node }) =>
                        node.drupal_parent_menu_item ===
                        `menu_link_content:${child.node.drupal_id}`
                    )
                    return (
                      <ul key={child.node.drupal_id} className={subNav}>
                        <SubItemContainer className={subNavName}>
                          <ProcessedLink link={child.node.link.uri}>
                            <SubItem>{child.node.title}</SubItem>
                          </ProcessedLink>
                        </SubItemContainer>
                        {menuLevelThree.length > 0 && (
                          <>
                            {menuLevelThree.map((lastChild) => {
                              return (
                                <SubNavItemTitle
                                  key={lastChild.node.drupal_id}
                                  className={subNavItemTitle}
                                >
                                  <ProcessedLink link={lastChild.node.link.uri}>
                                    {lastChild.node.title}
                                  </ProcessedLink>
                                </SubNavItemTitle>
                              )
                            })}
                          </>
                        )}
                      </ul>
                    )
                  })}
                </div>
              )}
            </NavItem>
          )
        })}
      </ul>
    </MainNav>
  )
}

//-----------------------Child Component---------------------------//

MainMenu.propTypes = {
  mainMenuData: PropTypes.array.isRequired,
}

export default MainMenu
